
import { computed, defineComponent, ref, watch, watchEffect } from 'vue'
import { useFormModule } from '@/modules/_shared/forms'
import QForm from 'quasar/src/components/form/QForm.js';
import { useOrganizationModule } from '@/modules/organizations'
import { useRoute } from 'vue-router'
import EditableSelect from '@/components/_shared/editable-select.vue'
import { useIndustryModule } from '@/modules/industries'

export default defineComponent({
    name: 'organizations-editable-field-industry',
    props: {
        modelValue: {
            type: String as () => string | null,
            required: true
        }
    },
    components: {
        EditableSelect
    },
    async setup (props, { emit }) {
        const route = useRoute()
        const { updateOrganizationIndustry } = useOrganizationModule()
        const { getIndustries, industries } = useIndustryModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const mappedNames = computed(() => industries.value.map(name => ({
            label: name.name,
            value: name.id
        })))
        const form = ref<QForm>()
        const localValue = ref(props.modelValue)

        watchEffect(() => {
            localValue.value = props.modelValue
        })

        watch(localValue, () => {
            submitForm(
                form.value,
                async () => updateOrganizationIndustry(
                    route.params.organizationId as string,
                    {
                        organizationId: route.params.organizationId as string,
                        industryId: localValue.value
                    }),
                () => {
                    emit('update:modelValue', localValue.value)
                    createOnSuccess('Organization industry updated')()
                }
            )
        })

        if (industries.value.length === 0) {
            await getIndustries()
        }
        const filteredOptions = ref(mappedNames.value)
        const filterFn = (val: string, update: (arg: () => void) => void) => {
            update(() => {
                const needle = val.toLowerCase()
                filteredOptions.value = mappedNames.value.filter(v => v.label.toLowerCase().indexOf(needle) > -1)
            })
        }
        return {
            filteredOptions,
            localValue,
            form,
            filterFn
        }
    }
})
